<template>
    <div ref="podcastScrollContainer" class="flex overflow-x-scroll hide-scroll-bar bg-white rounded-2xl p-3 md:p-4">
        <div class="flex space-x-3 md:space-x-5 flex-nowrap w-full">
            <div v-if="podcasts.length" class="inline-block">
                <div @click="open = true" class="inline-flex mb-1.5 flex-col items-center justify-center w-32 h-32 md:w-64 md:h-64 bg-gray-400 rounded-xl text-gray-800 space-y-2 cursor-pointer hover:bg-regal-blue-700 hover:text-white transition-colors duration-100 ease-in">
                    <svg class="w-6 h-6 " fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path></svg>
                </div>
                <div class="font-medium">
                    New podcast
                </div>
            </div>

            <div v-if="!podcasts.length" class="w-full inline-flex items-center justify-center">
                <div class="w-auto p-8 md:h-64 flex flex-col space-y-5 items-center justify-center">
                    <div class="flex flex-col items-center">
                        <svg class="w-8 h-8 mb-4 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z"></path></svg>
                        <div class="text-sm font-medium">
                            No podcast, yet.
                        </div>
                        <div class="text-gray-700 text-sm text-center">
                            Get started by creating a new podcast.
                        </div>
                    </div>

                    <div @click="open = true">
                        <Button label="New podcast"/>
                    </div>

                </div>
            </div>
            <div v-for="(podcast, index) in podcasts" :class="{ 'pr-4': index == podcasts.length - 1}" class="relative">
                <label>
                    <input type="radio" :value="podcast.uuid" v-model="selected" class="hidden"/>
                    <div class="inline-flex flex-col items-end justify-end w-32 h-32 md:w-64 md:h-64 bg-gray-400 rounded-xl cursor-pointer bg-center bg-cover border-4 mb-1.5 hover:border-regal-blue-400 transition-colors duration-100 ease-out" :style=" 'background-image: url(' + podcast.image || image + ')' " :class="{ 'border-4 border-regal-blue-700 hover:border-regal-blue-700': podcast.uuid == selected}">
                        <!-- <svg class="w-6 h-6 " fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path></svg> -->
                        <!-- <div class="flex items-center justify-center w-10 h-10 bg-gray-900 rounded-full bg-opacity-50 text-white m-2">
                            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z"></path></svg>
                        </div> -->
                        <div class="flex-1 w-full flex items-center justify-center">
                            <div v-if="podcast.uuid == selected" class="flex items-center justify-center w-16 h-16 bg-white bg-opacity-90 rounded-full">
                                <svg class="w-6 h-6 text-regal-blue-700" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path></svg>
                            </div>
                        </div>
                    </div>
                    <div class="w-full flex items-center">
                        <div class="flex-1">
                            <div class="flex justify-between items-center">
                                <div class="line-clamp-1 font-medium text-gray-800 leading-tight" :class="{ 'text-regal-blue-700': podcast.uuid == selected}">
                                    {{ podcast.title }}
                                </div>
                            </div>
                            <div class="text-sm text-gray-700 font-medium" :class="{ 'text-regal-blue-400': podcast.uuid == selected}">
                                 <div class="">
                                     {{ podcast.episodes }}
                                 </div>
                            </div>
                        </div>
                    </div>
                </label>
                <div @click.stop="editPodcast(podcast)" class="absolute bottom-1 right-0 p-1.5 text-gray-600 hover:text-gray-800 cursor-pointer transition-colors duration-100 ease-out rounded-full w-9 h-9 hover:bg-gray-400">
                    <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"></path></svg>
                </div>
            </div>
        </div>
    </div>

    <Modal v-model:open="open" @close="resetLoadedPodcast">
        <PodcastForm :categories="categories" v-model:open="open" :podcast="loadedPodcast" :template="template" v-model:isDirty="formIsDirty"/>
    </Modal>


</template>

<script>
import { ref } from 'vue'
import Button from '@/Shared/Button'
import Modal from '@/Shared/Modal'
import PodcastForm from '@/Shared/PodcastForm'

export default {
    setup(props) {
        const open = ref(false)
        const loadedPodcast = ref(null)
        const formIsDirty = ref(false)

        return { open, loadedPodcast, formIsDirty }

    },
    watch: {
        selected() {
            this.$emit('update:selected', this.selected)
        }
    },
    components: { Modal, PodcastForm, Button },
    props: [ 'selected', 'podcasts', 'categories', 'template' ],
    methods: {
        editPodcast(podcast) {
            this.open = true
            this.loadedPodcast = podcast
        },
        resetLoadedPodcast() {
            if (this.formIsDirty) {
                if (!window.confirm('Do you want to discard unsaved changes?')) {
                    this.open = true
                } else {
                    this.formIsDirty = false
                }
            }
            setTimeout(() => {this.loadedPodcast = null}, 200)
        }
    },
}
</script>
